import { PermisosService, Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import {  Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/primeng';

import { BreadcrumbService } from '../../breadcrumb.service';

import { TranslateService } from 'ng2-translate';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';

import { AlaFormulario } from '../../domain/AlaFormulario';
import { NivelFormulario } from '../../domain/NivelFormulario';
import { Constantes } from './../../domain/constantes';
import {
	Predicate
} from 'breeze-client';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { Idioma } from '../../domain/Idioma';
import { AppComponent } from '../../app.component';

@Component({
	selector: 'app-selector',
	templateUrl: './SelectorMapas.component.html',
	styleUrls: ['./SelectorMapas.component.scss'],
	providers: [ConfirmationService]
})

export class SelectorMapasComponent implements OnInit, OnDestroy {

	listaNiveles: any[] = [];
	spinner: HTMLElement;
	msgs: Message[] = [];
	uploadedFilesAla = [];
	imagenAlaSeleccionada: any;
	selectorImagenAla: any;

	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	/* ** @INPUTS de Formulario ** */
	alaSeleccionada: AlaFormulario = new AlaFormulario();
	nivelSeleccionado: NivelFormulario = new NivelFormulario();
	edicionAla: boolean;
	edicionNivel: boolean;

	/* ** @INPUTS de p-dialog ** */
	formAlaVisible: boolean;
	formNivelVisible: boolean;

	ASC = 1;
	DESC = -1;

	/* Permisos */
	permisos: Permisos = new Permisos();
	constructor(
		private appComponent: AppComponent,
		private breadcrumbService: BreadcrumbService,
		private router: Router,
		private entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private confirmationService: ConfirmationService,
		public idiomaService: IdiomaService,
		private translate: TranslateService,
		private permisosService: PermisosService
	)
	{
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Mapas.mapas') }
		]);
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		const that = this;
		this.entityManager.getIDIOMA()
		.then(function(idiomasENTIDAD: any ){

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			return that.comprobarPermisos();
		});
	}

  /* ** Funciones preparacion Vista  ** */
	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		this.cargarEntidades()
		.then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			console.log('*** prepararRutaSugeridasCell OK ***');
		})
		.catch(function(){
			console.log('*** Error: ngOnInit ***');
		});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	cargarEntidades(): Promise < any > {
		const that = this;

		return this.obtenerNIVEL()
		.then(function(niveles) {
			console.log(niveles)
			niveles.forEach(nivel => {
				for (let index = 0; index < nivel.ALAS.length; index++) {
					if (index === nivel.ALAS.length - 1) {
						const ala = nivel.ALAS[index];
						ala.esLaUltima = true;
					}
				}
			});
			return niveles;
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	obtenerNIVEL() {
		const that = this;
		const entityManager = that.entityManager;

		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		let includes = 'ESPACIO, ';
		includes = includes + 'ALAS.SECCIONS, ';
		includes = includes + 'ALAS.IDIOMAS, ';
		includes = includes + 'IDIOMAS';

		return entityManager.getNIVEL(predicado, includes)
		.then(function(niveles){

			that.listaNiveles = niveles;
			that.ordenarListaNiveles(that.ASC);

			return niveles;
		})
		.catch(function(e){
			that.appComponent.showError(e.message);
			return false;
		});
	}

	/* ** Acciones ALAS ** */
	crearAlaPresionado(nivel, event) {
		console.log(this.imagenAlaSeleccionada);
		this.alaSeleccionada = new AlaFormulario();
		this.nivelSeleccionado = nivel;
		this.alaSeleccionada.Idiomas = this.idiomaService.newMapAlaIdiomas(this.idiomas);
		this.edicionAla = false;
		this.formAlaVisible = true;
		console.log(this.imagenAlaSeleccionada);
	}

	editarAla(ala) {
		// this.alaSeleccionada = ala;
		console.log('ala = ' + ala);
		console.log('ala.ENTIDAD = ' + ala.ENTIDAD);
		this.router.navigate(['/mapas/editar', { id: ala.Id }]);
	}

	editarAlaPresionado(alaENTIDAD) {
		this.alaSeleccionada = new AlaFormulario(alaENTIDAD);
		// this.alaSeleccionada.Idiomas = this.idiomaService.getMapAlaIdiomas(alaENTIDAD.IDIOMAS);
		// this.alaSeleccionada.ENTIDAD = alaENTIDAD;
		// this.alaSeleccionada.Nomobre = alaENTIDAD.Nomobre;
		// this.alaSeleccionada.Descripcion = alaENTIDAD.Descripcion;

		// this.imagenAlaSeleccionada = undefined;
		// this.alaSeleccionada.Imagen = 'assets/itsoft/images/mini-plano.png';

		this.edicionAla = true;
		this.formAlaVisible = true;
	}

	/* ** Acciones NIVELES ** */
	crearNivelPresionado() {
		this.nivelSeleccionado = new NivelFormulario();
		this.nivelSeleccionado.Idiomas = this.idiomaService.newMapNivelIdiomas(this.idiomas);
		this.edicionNivel = false;
		this.formNivelVisible = true;
	}

	editarNivelPresionado(nivel) {
		this.nivelSeleccionado = nivel;
		this.nivelSeleccionado.Idiomas = this.idiomaService.getMapNivelIdiomas(nivel.IDIOMAS);
		this.edicionNivel = true;
		this.formNivelVisible = true;
	}

	eliminarNivelPresionado(nivel) {
		const that = this;

		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				that.spinner.style.display = 'inherit';

				this.nivelSeleccionado = nivel;
				return this.entityManager.deleteNIVEL(this.nivelSeleccionado)
				// return this.entityManager.saveChanges()
				.then(function() {
					that.listaNiveles = that.listaNiveles.filter((val, i) => val.Id !== nivel.Id);
					that.spinner.style.display = 'none';
				})
				.catch(function(e) {
					that.appComponent.showError(e.message);
					that.spinner.style.display = 'none';
					return false;
				});
			},
			reject: () => {
				that.spinner.style.display = 'none';
			}
		});
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}


	/* *** @Outlets de Formulario Ala *** */
	onElementoAlaGuardado($event){
		console.log('onElementoGuardado');
		this.formAlaVisible = false;
		this.appComponent.showSuccess(this.translate.instant('elementoGuardadoCorrectamente'));
		this.spinner.style.display = 'none';
	}

	onElementoAlaEliminado($event){
		this.formAlaVisible = false;
		this.appComponent.showSuccess(this.translate.instant('elementoEliminadoCorrectamente'));
		this.spinner.style.display = 'none';
	}

	/* *** @Outlets de Formulario Nivel *** */
	onElementoNivelGuardado($event){
		if (!this.edicionNivel) {
			this.listaNiveles.push($event);
		}
		this.ordenarListaNiveles(this.ASC);

		this.formNivelVisible = false;
		this.appComponent.showSuccess(this.translate.instant('elementoGuardadoCorrectamente'));
		this.spinner.style.display = 'none';
	}

	onElementoNivelEliminado($event){
		this.ordenarListaNiveles(this.ASC);
		this.formNivelVisible = false;
		this.appComponent.showSuccess(this.translate.instant('elementoEliminadoCorrectamente'));
		this.spinner.style.display = 'none';
	}

	onElementoError($evento) {
		this.appComponent.showError($evento);
	}

	mostrarEditar(ala) {
		// Muestra u Oculta el boton editar al pasar el raton por encima del elemento
		ala.editarVisible = true;
	}

	ocultarEditar(ala) {
		// Muestra u Oculta el boton editar al pasar el raton por encima del elemento
		ala.editarVisible = false;
	}

	downloadFile(fileName) {
		if (fileName === 'Guia_de_Refencia_de_estilos.pdf') {
			return this.sws.downloadFile(Constantes.Guia_de_Refencia_de_estilos, fileName);
		}
	}

	ordenarListaNiveles(order){
		this.listaNiveles.sort( (one: any, two: any) => {
			// Ordenamos descendente
			return one.NivelVertical > two.NivelVertical ? 1 * order : -1 * order;
		});
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/mapas/SelectorMapas.component.ts